module.exports = __webpack_public_path__ + "img/main-img.d4f0ad57.jpg";